import React from 'react';
import { Mail, MessageCircle, CheckCircle2 } from 'lucide-react';

const STEPS = [
  {
    icon: Mail,
    accent: 'brand-primary',
    title: 'Email Confirmation',
    description:
      "You'll receive a confirmation email with program details and payment receipt.",
  },
  {
    icon: MessageCircle,
    accent: 'brand-accent',
    title: 'WhatsApp Confirmation',
    description:
      'Our team will reach out via WhatsApp to schedule your first session.',
  },
  {
    icon: CheckCircle2,
    accent: 'brand-primary',
    title: 'Program Kickoff',
    description:
      "Within 24 hours, you'll receive your personalised program plan and access details.",
  },
];

const NextStepsCard = () => (
  <div
    className="network-card p-8 mb-8"
    data-testid="payment-success-next-steps"
  >
    <h3 className="text-xl font-bold text-white mb-4">What Happens Next?</h3>
    <div className="space-y-4">
      {STEPS.map((step) => {
        const Icon = step.icon;
        return (
          <div key={`step-${step.title}`} className="flex items-start gap-4">
            <div
              className={`w-8 h-8 rounded-full bg-${step.accent}/20 flex items-center justify-center flex-shrink-0`}
            >
              <Icon className={`text-${step.accent}`} size={18} aria-hidden="true" />
            </div>
            <div>
              <p className="text-white font-semibold">{step.title}</p>
              <p className="text-text-secondary text-sm">{step.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default NextStepsCard;
